import http from "../http-common";

class FinishCabinetDoorDataService {
  getAll() {
    return http.get("/finishcabinetdoors");
  }

  getFinishCabinetByDescr(condition, sortfield,sorttype) {
    return http.get(`/finishcabinetdoors/search/?finishcabinetdoor=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/finishcabinetdoors/${id}`);
  }

  create(data) {
    return http.post("/finishcabinetdoors/newfinishcabinetdoors", data);
  }

  update(id, data) {
    return http.put(`/finishcabinetdoors/${id}`, data);
  }

  delete(id) {
    return http.delete(`/finishcabinetdoors/${id}`);
  }

  deleteAll() {
    return http.delete(`/finishcabinetdoors`);
  }

  findById(id) {
    return http.get(`/finishcabinetdoors?id=${id}`);
  }
}

export default new FinishCabinetDoorDataService();